module.exports = __webpack_public_path__ + "static/media/discover_3.7125190f.svg";